import React from "react";

export default () => <h1>Page Does Not Exist</h1>;
